/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompetitorCreate,
  CompetitorRead,
  CompetitorUpdate,
  EventAdministratorCreate,
  EventAdministratorRead,
  EventAnnouncementCreate,
  EventCreate,
  EventMeRead,
  EventMineRead,
  EventOrganizationCreate,
  EventOrganizationMemberRead,
  EventOrganizationRead,
  EventQuestionAnswer,
  EventQuestionCreate,
  EventQuestionOwnRead,
  EventQuestionPublish,
  EventQuestionRead,
  EventQuestionSummary,
  EventQuestionsRead,
  EventRead,
  EventRejudgeRead,
  EventResults,
  EventState,
  EventUpdate,
  EventUpdateRead,
  HTTPValidationError,
  SubmissionRead,
  SubmissionReadFull,
  TeamCreate,
  TeamJoin,
} from '../models/index';
import {
    CompetitorCreateFromJSON,
    CompetitorCreateToJSON,
    CompetitorReadFromJSON,
    CompetitorReadToJSON,
    CompetitorUpdateFromJSON,
    CompetitorUpdateToJSON,
    EventAdministratorCreateFromJSON,
    EventAdministratorCreateToJSON,
    EventAdministratorReadFromJSON,
    EventAdministratorReadToJSON,
    EventAnnouncementCreateFromJSON,
    EventAnnouncementCreateToJSON,
    EventCreateFromJSON,
    EventCreateToJSON,
    EventMeReadFromJSON,
    EventMeReadToJSON,
    EventMineReadFromJSON,
    EventMineReadToJSON,
    EventOrganizationCreateFromJSON,
    EventOrganizationCreateToJSON,
    EventOrganizationMemberReadFromJSON,
    EventOrganizationMemberReadToJSON,
    EventOrganizationReadFromJSON,
    EventOrganizationReadToJSON,
    EventQuestionAnswerFromJSON,
    EventQuestionAnswerToJSON,
    EventQuestionCreateFromJSON,
    EventQuestionCreateToJSON,
    EventQuestionOwnReadFromJSON,
    EventQuestionOwnReadToJSON,
    EventQuestionPublishFromJSON,
    EventQuestionPublishToJSON,
    EventQuestionReadFromJSON,
    EventQuestionReadToJSON,
    EventQuestionSummaryFromJSON,
    EventQuestionSummaryToJSON,
    EventQuestionsReadFromJSON,
    EventQuestionsReadToJSON,
    EventReadFromJSON,
    EventReadToJSON,
    EventRejudgeReadFromJSON,
    EventRejudgeReadToJSON,
    EventResultsFromJSON,
    EventResultsToJSON,
    EventStateFromJSON,
    EventStateToJSON,
    EventUpdateFromJSON,
    EventUpdateToJSON,
    EventUpdateReadFromJSON,
    EventUpdateReadToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    SubmissionReadFromJSON,
    SubmissionReadToJSON,
    SubmissionReadFullFromJSON,
    SubmissionReadFullToJSON,
    TeamCreateFromJSON,
    TeamCreateToJSON,
    TeamJoinFromJSON,
    TeamJoinToJSON,
} from '../models/index';

export interface AcceptInvitationRequest {
    eventId: string;
    organizationId: string;
}

export interface AddEventAdministratorRequest {
    eventId: string;
    eventAdministratorCreate: EventAdministratorCreate;
}

export interface AnswerEventQuestionRequest {
    eventId: string;
    questionId: string;
    eventQuestionAnswer: EventQuestionAnswer;
}

export interface AskEventQuestionRequest {
    eventId: string;
    eventQuestionCreate: EventQuestionCreate;
}

export interface CreateCompetitorRequest {
    eventId: string;
    competitorCreate: CompetitorCreate;
}

export interface CreateEventRequest {
    eventCreate: EventCreate;
}

export interface CreateEventAnnouncementRequest {
    eventId: string;
    eventAnnouncementCreate: EventAnnouncementCreate;
}

export interface CreateTeamRequest {
    eventId: string;
    teamCreate: TeamCreate;
}

export interface DeleteCompetitorRequest {
    eventId: string;
    competitorId: string;
}

export interface DeleteEventRequest {
    eventId: string;
}

export interface DeleteEventQuestionRequest {
    eventId: string;
    questionId: string;
}

export interface GetEventRequest {
    eventId: string;
}

export interface GetEventQuestionSummaryRequest {
    eventId: string;
}

export interface GetEventResultsRequest {
    eventId: string;
    organizationId?: string | null;
}

export interface GetMyEventRequest {
    eventId: string;
}

export interface InviteOrganizationRequest {
    eventId: string;
    eventOrganizationCreate: EventOrganizationCreate;
}

export interface JoinEventRequest {
    eventId: string;
    xOrganizationID?: string | null;
}

export interface JoinTeamRequest {
    eventId: string;
    teamJoin: TeamJoin;
}

export interface LeaveTeamRequest {
    eventId: string;
}

export interface ListCompetitorSubmissionsRequest {
    eventId: string;
    competitorId: string;
    problemId?: string | null;
}

export interface ListCompetitorsRequest {
    eventId: string;
}

export interface ListEventAdministratorsRequest {
    eventId: string;
}

export interface ListEventOrganizationMembersRequest {
    eventId: string;
    organizationId: string;
}

export interface ListEventOrganizationsRequest {
    eventId: string;
}

export interface ListEventQuestionsRequest {
    eventId: string;
}

export interface ListEventsRequest {
    competitionId?: string | null;
    organizationId?: string | null;
    state?: EventState | null;
}

export interface PublishEventQuestionRequest {
    eventId: string;
    questionId: string;
    eventQuestionPublish: EventQuestionPublish;
}

export interface RejudgeEventRequest {
    eventId: string;
}

export interface RemoveEventAdministratorRequest {
    eventId: string;
    userId: string;
}

export interface RemoveOrganizationRequest {
    eventId: string;
    organizationId: string;
}

export interface StartOrganizationRequest {
    eventId: string;
    organizationId: string;
}

export interface SubmitEventCodeRequest {
    eventId: string;
    codeId: string;
}

export interface UnpublishEventQuestionRequest {
    eventId: string;
    questionId: string;
}

export interface UpdateCompetitorRequest {
    eventId: string;
    competitorId: string;
    competitorUpdate: CompetitorUpdate;
}

export interface UpdateEventRequest {
    eventId: string;
    eventUpdate: EventUpdate;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Accept an invitation to an event; an admin of the invited organization only.
     * Accept Invitation
     */
    async acceptInvitationRaw(requestParameters: AcceptInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventOrganizationRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling acceptInvitation().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling acceptInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations/{organization_id}/accept`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventOrganizationReadFromJSON(jsonValue));
    }

    /**
     * Accept an invitation to an event; an admin of the invited organization only.
     * Accept Invitation
     */
    async acceptInvitation(requestParameters: AcceptInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventOrganizationRead> {
        const response = await this.acceptInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add an administrator to an event; its creator or a superadmin only. The user must hold the competition organizer role (400 otherwise, 400 when they already run the event).
     * Add Event Administrator
     */
    async addEventAdministratorRaw(requestParameters: AddEventAdministratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventAdministratorRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling addEventAdministrator().'
            );
        }

        if (requestParameters['eventAdministratorCreate'] == null) {
            throw new runtime.RequiredError(
                'eventAdministratorCreate',
                'Required parameter "eventAdministratorCreate" was null or undefined when calling addEventAdministrator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/administrators`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventAdministratorCreateToJSON(requestParameters['eventAdministratorCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventAdministratorReadFromJSON(jsonValue));
    }

    /**
     * Add an administrator to an event; its creator or a superadmin only. The user must hold the competition organizer role (400 otherwise, 400 when they already run the event).
     * Add Event Administrator
     */
    async addEventAdministrator(requestParameters: AddEventAdministratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventAdministratorRead> {
        const response = await this.addEventAdministratorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Answer a question, or replace its answer; the event\'s creator, a superadmin or an administrator. The asker sees the answer privately until it is published.
     * Answer Event Question
     */
    async answerEventQuestionRaw(requestParameters: AnswerEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling answerEventQuestion().'
            );
        }

        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling answerEventQuestion().'
            );
        }

        if (requestParameters['eventQuestionAnswer'] == null) {
            throw new runtime.RequiredError(
                'eventQuestionAnswer',
                'Required parameter "eventQuestionAnswer" was null or undefined when calling answerEventQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions/{question_id}/answer`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters['questionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EventQuestionAnswerToJSON(requestParameters['eventQuestionAnswer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionReadFromJSON(jsonValue));
    }

    /**
     * Answer a question, or replace its answer; the event\'s creator, a superadmin or an administrator. The asker sees the answer privately until it is published.
     * Answer Event Question
     */
    async answerEventQuestion(requestParameters: AnswerEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionRead> {
        const response = await this.answerEventQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ask the event\'s administrators a question; a member of a team of the event or an admin of an organization listed on it, while the event is open for them (409 otherwise). Organizers and administrators 403; 429 past the hourly or daily limit.
     * Ask Event Question
     */
    async askEventQuestionRaw(requestParameters: AskEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionOwnRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling askEventQuestion().'
            );
        }

        if (requestParameters['eventQuestionCreate'] == null) {
            throw new runtime.RequiredError(
                'eventQuestionCreate',
                'Required parameter "eventQuestionCreate" was null or undefined when calling askEventQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventQuestionCreateToJSON(requestParameters['eventQuestionCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionOwnReadFromJSON(jsonValue));
    }

    /**
     * Ask the event\'s administrators a question; a member of a team of the event or an admin of an organization listed on it, while the event is open for them (409 otherwise). Organizers and administrators 403; 429 past the hourly or daily limit.
     * Ask Event Question
     */
    async askEventQuestion(requestParameters: AskEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionOwnRead> {
        const response = await this.askEventQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register a team: organization events before the organization starts (organizer or its admin); user events before the window opens (organizer only).
     * Create Competitor
     */
    async createCompetitorRaw(requestParameters: CreateCompetitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitorRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling createCompetitor().'
            );
        }

        if (requestParameters['competitorCreate'] == null) {
            throw new runtime.RequiredError(
                'competitorCreate',
                'Required parameter "competitorCreate" was null or undefined when calling createCompetitor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/competitors`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitorCreateToJSON(requestParameters['competitorCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitorReadFromJSON(jsonValue));
    }

    /**
     * Register a team: organization events before the organization starts (organizer or its admin); user events before the window opens (organizer only).
     * Create Competitor
     */
    async createCompetitor(requestParameters: CreateCompetitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitorRead> {
        const response = await this.createCompetitorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an event of the caller\'s own competition; competition organizers only.
     * Create Event
     */
    async createEventRaw(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventRead>> {
        if (requestParameters['eventCreate'] == null) {
            throw new runtime.RequiredError(
                'eventCreate',
                'Required parameter "eventCreate" was null or undefined when calling createEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateToJSON(requestParameters['eventCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventReadFromJSON(jsonValue));
    }

    /**
     * Create an event of the caller\'s own competition; competition organizers only.
     * Create Event
     */
    async createEvent(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventRead> {
        const response = await this.createEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish a clarification nobody asked about to everyone who reads the event; the event\'s creator, a superadmin or an administrator.
     * Create Event Announcement
     */
    async createEventAnnouncementRaw(requestParameters: CreateEventAnnouncementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling createEventAnnouncement().'
            );
        }

        if (requestParameters['eventAnnouncementCreate'] == null) {
            throw new runtime.RequiredError(
                'eventAnnouncementCreate',
                'Required parameter "eventAnnouncementCreate" was null or undefined when calling createEventAnnouncement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/announcements`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventAnnouncementCreateToJSON(requestParameters['eventAnnouncementCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionReadFromJSON(jsonValue));
    }

    /**
     * Publish a clarification nobody asked about to everyone who reads the event; the event\'s creator, a superadmin or an administrator.
     * Create Event Announcement
     */
    async createEventAnnouncement(requestParameters: CreateEventAnnouncementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionRead> {
        const response = await this.createEventAnnouncementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a team in a public user event with the caller as its first member; returns its join code. Any registered user, until the window ends.
     * Create Team
     */
    async createTeamRaw(requestParameters: CreateTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitorRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling createTeam().'
            );
        }

        if (requestParameters['teamCreate'] == null) {
            throw new runtime.RequiredError(
                'teamCreate',
                'Required parameter "teamCreate" was null or undefined when calling createTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/teams`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TeamCreateToJSON(requestParameters['teamCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitorReadFromJSON(jsonValue));
    }

    /**
     * Create a team in a public user event with the caller as its first member; returns its join code. Any registered user, until the window ends.
     * Create Team
     */
    async createTeam(requestParameters: CreateTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitorRead> {
        const response = await this.createTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a team: organization events before the organization starts (organizer or its admin); user events before the window opens (organizer only).
     * Delete Competitor
     */
    async deleteCompetitorRaw(requestParameters: DeleteCompetitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteCompetitor().'
            );
        }

        if (requestParameters['competitorId'] == null) {
            throw new runtime.RequiredError(
                'competitorId',
                'Required parameter "competitorId" was null or undefined when calling deleteCompetitor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/competitors/{competitor_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"competitor_id"}}`, encodeURIComponent(String(requestParameters['competitorId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a team: organization events before the organization starts (organizer or its admin); user events before the window opens (organizer only).
     * Delete Competitor
     */
    async deleteCompetitor(requestParameters: DeleteCompetitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompetitorRaw(requestParameters, initOverrides);
    }

    /**
     * Delete an event with its organizations, competitors and administrators; the event\'s creator or a superadmin only (an event administrator cannot).
     * Delete Event
     */
    async deleteEventRaw(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an event with its organizations, competitors and administrators; the event\'s creator or a superadmin only (an event administrator cannot).
     * Delete Event
     */
    async deleteEvent(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a question; the event\'s creator, a superadmin or an administrator always, the asker while it is unanswered (403 after). The asker\'s delete withdraws it: it disappears from every list but still counts towards their rate limit. Other readers get 404, as for an unknown question.
     * Delete Event Question
     */
    async deleteEventQuestionRaw(requestParameters: DeleteEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteEventQuestion().'
            );
        }

        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling deleteEventQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions/{question_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters['questionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a question; the event\'s creator, a superadmin or an administrator always, the asker while it is unanswered (403 after). The asker\'s delete withdraws it: it disappears from every list but still counts towards their rate limit. Other readers get 404, as for an unknown question.
     * Delete Event Question
     */
    async deleteEventQuestion(requestParameters: DeleteEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventQuestionRaw(requestParameters, initOverrides);
    }

    /**
     * Get one event with its state; any authenticated user who may read it, otherwise 404.
     * Get Event
     */
    async getEventRaw(requestParameters: GetEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling getEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventReadFromJSON(jsonValue));
    }

    /**
     * Get one event with its state; any authenticated user who may read it, otherwise 404.
     * Get Event
     */
    async getEvent(requestParameters: GetEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventRead> {
        const response = await this.getEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The number of unanswered questions; the event\'s creator, a superadmin or an administrator.
     * Get Event Question Summary
     */
    async getEventQuestionSummaryRaw(requestParameters: GetEventQuestionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionSummary>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling getEventQuestionSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions/summary`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionSummaryFromJSON(jsonValue));
    }

    /**
     * The number of unanswered questions; the event\'s creator, a superadmin or an administrator.
     * Get Event Question Summary
     */
    async getEventQuestionSummary(requestParameters: GetEventQuestionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionSummary> {
        const response = await this.getEventQuestionSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Event results; organizer always, admins of started organizations and competitor members per the visibility rules, everyone involved once the event is closed. Under feedback level none (for non-organizers) rows carry no rank, total or points; the response reports the applied level in `feedback`.
     * Get Event Results
     */
    async getEventResultsRaw(requestParameters: GetEventResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventResults>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling getEventResults().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/results`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventResultsFromJSON(jsonValue));
    }

    /**
     * Event results; organizer always, admins of started organizations and competitor members per the visibility rules, everyone involved once the event is closed. Under feedback level none (for non-organizers) rows carry no rank, total or points; the response reports the applied level in `feedback`.
     * Get Event Results
     */
    async getEventResults(requestParameters: GetEventResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventResults> {
        const response = await this.getEventResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the caller\'s own view of an event with their team, clock and problems; competitor members only.
     * Get My Event
     */
    async getMyEventRaw(requestParameters: GetMyEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventMeRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling getMyEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/me`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventMeReadFromJSON(jsonValue));
    }

    /**
     * Get the caller\'s own view of an event with their team, clock and problems; competitor members only.
     * Get My Event
     */
    async getMyEvent(requestParameters: GetMyEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventMeRead> {
        const response = await this.getMyEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite an organization to an event; the event\'s creator, a superadmin or an administrator.
     * Invite Organization
     */
    async inviteOrganizationRaw(requestParameters: InviteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventOrganizationRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling inviteOrganization().'
            );
        }

        if (requestParameters['eventOrganizationCreate'] == null) {
            throw new runtime.RequiredError(
                'eventOrganizationCreate',
                'Required parameter "eventOrganizationCreate" was null or undefined when calling inviteOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventOrganizationCreateToJSON(requestParameters['eventOrganizationCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventOrganizationReadFromJSON(jsonValue));
    }

    /**
     * Invite an organization to an event; the event\'s creator, a superadmin or an administrator.
     * Invite Organization
     */
    async inviteOrganization(requestParameters: InviteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventOrganizationRead> {
        const response = await this.inviteOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Join a public event with the organization in X-Organization-ID; its admin only.
     * Join Event
     */
    async joinEventRaw(requestParameters: JoinEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventOrganizationRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling joinEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations/join`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventOrganizationReadFromJSON(jsonValue));
    }

    /**
     * Join a public event with the organization in X-Organization-ID; its admin only.
     * Join Event
     */
    async joinEvent(requestParameters: JoinEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventOrganizationRead> {
        const response = await this.joinEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Join a team of a public user event with its join code; returns the caller\'s team only. Any registered user, until the window ends. 429 after too many unknown codes in the last hour or day, across all events.
     * Join Team
     */
    async joinTeamRaw(requestParameters: JoinTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitorRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling joinTeam().'
            );
        }

        if (requestParameters['teamJoin'] == null) {
            throw new runtime.RequiredError(
                'teamJoin',
                'Required parameter "teamJoin" was null or undefined when calling joinTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/teams/join`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TeamJoinToJSON(requestParameters['teamJoin']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitorReadFromJSON(jsonValue));
    }

    /**
     * Join a team of a public user event with its join code; returns the caller\'s team only. Any registered user, until the window ends. 429 after too many unknown codes in the last hour or day, across all events.
     * Join Team
     */
    async joinTeam(requestParameters: JoinTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitorRead> {
        const response = await this.joinTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Leave the caller\'s team of a public user event before the window opens; an empty team is deleted.
     * Leave Team
     */
    async leaveTeamRaw(requestParameters: LeaveTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling leaveTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/teams/me`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Leave the caller\'s team of a public user event before the window opens; an empty team is deleted.
     * Leave Team
     */
    async leaveTeam(requestParameters: LeaveTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.leaveTeamRaw(requestParameters, initOverrides);
    }

    /**
     * A team\'s submissions in the event, newest first, optionally for one problem; the organizer, the team\'s members and admins of its organization, each row at the caller\'s feedback level.
     * List Competitor Submissions
     */
    async listCompetitorSubmissionsRaw(requestParameters: ListCompetitorSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubmissionReadFull>>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling listCompetitorSubmissions().'
            );
        }

        if (requestParameters['competitorId'] == null) {
            throw new runtime.RequiredError(
                'competitorId',
                'Required parameter "competitorId" was null or undefined when calling listCompetitorSubmissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['problemId'] != null) {
            queryParameters['problem_id'] = requestParameters['problemId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/competitors/{competitor_id}/submissions`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"competitor_id"}}`, encodeURIComponent(String(requestParameters['competitorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubmissionReadFullFromJSON));
    }

    /**
     * A team\'s submissions in the event, newest first, optionally for one problem; the organizer, the team\'s members and admins of its organization, each row at the caller\'s feedback level.
     * List Competitor Submissions
     */
    async listCompetitorSubmissions(requestParameters: ListCompetitorSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubmissionReadFull>> {
        const response = await this.listCompetitorSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the competitors the caller may see; organizers all, admins their organization\'s, members their own team.
     * List Competitors
     */
    async listCompetitorsRaw(requestParameters: ListCompetitorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitorRead>>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling listCompetitors().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/competitors`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetitorReadFromJSON));
    }

    /**
     * List the competitors the caller may see; organizers all, admins their organization\'s, members their own team.
     * List Competitors
     */
    async listCompetitors(requestParameters: ListCompetitorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitorRead>> {
        const response = await this.listCompetitorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the administrators of an event; its creator, a superadmin or an administrator. 403 for other readers, 404 when the event is hidden from the caller.
     * List Event Administrators
     */
    async listEventAdministratorsRaw(requestParameters: ListEventAdministratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventAdministratorRead>>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling listEventAdministrators().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/administrators`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventAdministratorReadFromJSON));
    }

    /**
     * List the administrators of an event; its creator, a superadmin or an administrator. 403 for other readers, 404 when the event is hidden from the caller.
     * List Event Administrators
     */
    async listEventAdministrators(requestParameters: ListEventAdministratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventAdministratorRead>> {
        const response = await this.listEventAdministratorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the active members of a listed organization (event organizer or that organization\'s administrators).
     * List Event Organization Members
     */
    async listEventOrganizationMembersRaw(requestParameters: ListEventOrganizationMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventOrganizationMemberRead>>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling listEventOrganizationMembers().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling listEventOrganizationMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations/{organization_id}/members`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventOrganizationMemberReadFromJSON));
    }

    /**
     * List the active members of a listed organization (event organizer or that organization\'s administrators).
     * List Event Organization Members
     */
    async listEventOrganizationMembers(requestParameters: ListEventOrganizationMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventOrganizationMemberRead>> {
        const response = await this.listEventOrganizationMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List an event\'s organizations; organizers and admins of listed organizations only.
     * List Event Organizations
     */
    async listEventOrganizationsRaw(requestParameters: ListEventOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventOrganizationRead>>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling listEventOrganizations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventOrganizationReadFromJSON));
    }

    /**
     * List an event\'s organizations; organizers and admins of listed organizations only.
     * List Event Organizations
     */
    async listEventOrganizations(requestParameters: ListEventOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventOrganizationRead>> {
        const response = await this.listEventOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The event\'s questions as the caller may see them; anyone who may read the event, else 404.  The event\'s creator, a superadmin or an administrator gets every question with its asker in `items`; everyone else gets `items` null and their own questions in `own`. Everyone gets the published questions and announcements in `published`, which identify nobody.
     * List Event Questions
     */
    async listEventQuestionsRaw(requestParameters: ListEventQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionsRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling listEventQuestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionsReadFromJSON(jsonValue));
    }

    /**
     * The event\'s questions as the caller may see them; anyone who may read the event, else 404.  The event\'s creator, a superadmin or an administrator gets every question with its asker in `items`; everyone else gets `items` null and their own questions in `own`. Everyone gets the published questions and announcements in `published`, which identify nobody.
     * List Event Questions
     */
    async listEventQuestions(requestParameters: ListEventQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionsRead> {
        const response = await this.listEventQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the events the caller may read; any authenticated user, filtered by visibility.
     * List Events
     */
    async listEventsRaw(requestParameters: ListEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventRead>>> {
        const queryParameters: any = {};

        if (requestParameters['competitionId'] != null) {
            queryParameters['competition_id'] = requestParameters['competitionId'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventReadFromJSON));
    }

    /**
     * List the events the caller may read; any authenticated user, filtered by visibility.
     * List Events
     */
    async listEvents(requestParameters: ListEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventRead>> {
        const response = await this.listEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the events the caller competes in with their clock state; any authenticated user.
     * List My Events
     */
    async listMyEventsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventMineRead>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/mine`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventMineReadFromJSON));
    }

    /**
     * List the events the caller competes in with their clock state; any authenticated user.
     * List My Events
     */
    async listMyEvents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventMineRead>> {
        const response = await this.listMyEventsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Publish an answered question for everyone with a possibly reworded text, or republish it; the event\'s creator, a superadmin or an administrator. 409 when it has no answer or is an announcement.
     * Publish Event Question
     */
    async publishEventQuestionRaw(requestParameters: PublishEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling publishEventQuestion().'
            );
        }

        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling publishEventQuestion().'
            );
        }

        if (requestParameters['eventQuestionPublish'] == null) {
            throw new runtime.RequiredError(
                'eventQuestionPublish',
                'Required parameter "eventQuestionPublish" was null or undefined when calling publishEventQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions/{question_id}/publish`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters['questionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventQuestionPublishToJSON(requestParameters['eventQuestionPublish']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionReadFromJSON(jsonValue));
    }

    /**
     * Publish an answered question for everyone with a possibly reworded text, or republish it; the event\'s creator, a superadmin or an administrator. 409 when it has no answer or is an announcement.
     * Publish Event Question
     */
    async publishEventQuestion(requestParameters: PublishEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionRead> {
        const response = await this.publishEventQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queue a re-judge of every submission of the event (judge only, no re-execution); the event\'s creator, a superadmin or an event administrator. 503 when the re-judge cannot be queued.
     * Rejudge Event
     */
    async rejudgeEventRaw(requestParameters: RejudgeEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventRejudgeRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling rejudgeEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/rejudge`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventRejudgeReadFromJSON(jsonValue));
    }

    /**
     * Queue a re-judge of every submission of the event (judge only, no re-execution); the event\'s creator, a superadmin or an event administrator. 503 when the re-judge cannot be queued.
     * Rejudge Event
     */
    async rejudgeEvent(requestParameters: RejudgeEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventRejudgeRead> {
        const response = await this.rejudgeEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove an administrator from an event; its creator or a superadmin, or the administrator themselves.
     * Remove Event Administrator
     */
    async removeEventAdministratorRaw(requestParameters: RemoveEventAdministratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling removeEventAdministrator().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling removeEventAdministrator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/administrators/{user_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove an administrator from an event; its creator or a superadmin, or the administrator themselves.
     * Remove Event Administrator
     */
    async removeEventAdministrator(requestParameters: RemoveEventAdministratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeEventAdministratorRaw(requestParameters, initOverrides);
    }

    /**
     * Remove an organization before it starts; the event\'s organizer or that organization\'s admin.
     * Remove Organization
     */
    async removeOrganizationRaw(requestParameters: RemoveOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling removeOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling removeOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations/{organization_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove an organization before it starts; the event\'s organizer or that organization\'s admin.
     * Remove Organization
     */
    async removeOrganization(requestParameters: RemoveOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * Start an organization\'s run once; the event\'s organizer or that organization\'s admin.
     * Start Organization
     */
    async startOrganizationRaw(requestParameters: StartOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventOrganizationRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling startOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling startOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/organizations/{organization_id}/start`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventOrganizationReadFromJSON(jsonValue));
    }

    /**
     * Start an organization\'s run once; the event\'s organizer or that organization\'s admin.
     * Start Organization
     */
    async startOrganization(requestParameters: StartOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventOrganizationRead> {
        const response = await this.startOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit the caller\'s saved code to an event problem before the deadline; competitor members only, 429 with Retry-After within the submission cooldown.
     * Submit Event Code
     */
    async submitEventCodeRaw(requestParameters: SubmitEventCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling submitEventCode().'
            );
        }

        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling submitEventCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/submissions/code/{code_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionReadFromJSON(jsonValue));
    }

    /**
     * Submit the caller\'s saved code to an event problem before the deadline; competitor members only, 429 with Retry-After within the submission cooldown.
     * Submit Event Code
     */
    async submitEventCode(requestParameters: SubmitEventCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionRead> {
        const response = await this.submitEventCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Take a question off the published list; the event\'s creator, a superadmin or an administrator. Returns the question, now answered but unpublished; 409 for an announcement (delete it instead).
     * Unpublish Event Question
     */
    async unpublishEventQuestionRaw(requestParameters: UnpublishEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventQuestionRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling unpublishEventQuestion().'
            );
        }

        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling unpublishEventQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/questions/{question_id}/publish`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters['questionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventQuestionReadFromJSON(jsonValue));
    }

    /**
     * Take a question off the published list; the event\'s creator, a superadmin or an administrator. Returns the question, now answered but unpublished; 409 for an announcement (delete it instead).
     * Unpublish Event Question
     */
    async unpublishEventQuestion(requestParameters: UnpublishEventQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventQuestionRead> {
        const response = await this.unpublishEventQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rename a team or change its members: organization events before the organization starts (organizer or its admin); user events before the window opens (organizer only).
     * Update Competitor
     */
    async updateCompetitorRaw(requestParameters: UpdateCompetitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitorRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling updateCompetitor().'
            );
        }

        if (requestParameters['competitorId'] == null) {
            throw new runtime.RequiredError(
                'competitorId',
                'Required parameter "competitorId" was null or undefined when calling updateCompetitor().'
            );
        }

        if (requestParameters['competitorUpdate'] == null) {
            throw new runtime.RequiredError(
                'competitorUpdate',
                'Required parameter "competitorUpdate" was null or undefined when calling updateCompetitor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}/competitors/{competitor_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))).replace(`{${"competitor_id"}}`, encodeURIComponent(String(requestParameters['competitorId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitorUpdateToJSON(requestParameters['competitorUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitorReadFromJSON(jsonValue));
    }

    /**
     * Rename a team or change its members: organization events before the organization starts (organizer or its admin); user events before the window opens (organizer only).
     * Update Competitor
     */
    async updateCompetitor(requestParameters: UpdateCompetitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitorRead> {
        const response = await this.updateCompetitorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Partially update an event; the event\'s creator, a superadmin or an event administrator.  A changed judging field re-judges the event\'s submissions. When that re-judge cannot be queued the update is still saved and `rejudge_failed` is true; retry it with `POST /judge/events/{event_id}/rejudge`.
     * Update Event
     */
    async updateEventRaw(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventUpdateRead>> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling updateEvent().'
            );
        }

        if (requestParameters['eventUpdate'] == null) {
            throw new runtime.RequiredError(
                'eventUpdate',
                'Required parameter "eventUpdate" was null or undefined when calling updateEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/events/{event_id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EventUpdateToJSON(requestParameters['eventUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventUpdateReadFromJSON(jsonValue));
    }

    /**
     * Partially update an event; the event\'s creator, a superadmin or an event administrator.  A changed judging field re-judges the event\'s submissions. When that re-judge cannot be queued the update is still saved and `rejudge_failed` is true; retry it with `POST /judge/events/{event_id}/rejudge`.
     * Update Event
     */
    async updateEvent(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventUpdateRead> {
        const response = await this.updateEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
